export class AbtastyRecommend extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    if (this.idRecommend != "") {
      this.getRecommendedProductList();
      this.initIntersectionObserver();
    }
    document.addEventListener('recommend:refresh', (event) => {
      this.getRecommendedProductList(event.detail.cartItems);
    }, { signal: this.abortController.signal });
  }

  get contentElement() {
    return this.querySelector('.recommend-list');
  }

  get idRecommend() {
    return this.getAttribute('id-recommend')
  }

  get productCardType() {
    return this.getAttribute('data-card');
  }

  get dataKlaviyo() {
    return this.hasAttribute('data-klaviyo')
  }

  get isSlider() {
    return this.hasAttribute('is-slider')
  }

  get currentProduct() {
    return this.getAttribute('data-product')
  }

  get viewingItems() {
    const items = new Set(JSON.parse(localStorage.getItem('recently_viewed') || '[]'));
    return Array.from(items);
  }

  get cartItems() {
    const cartItems = Object.values(window.shop.abtasty.recommend.cartContent).map(id => id.toString());
    return cartItems;
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.setAttribute('data-reco-id', this.idRecommend);
          obs.unobserve(this);
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(this);
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  slickManager() {
    // init slider
    let $slider = $(this).find('.slider-show-wrapper');
    if ($slider && !$slider.hasClass('slick-initialized')) {
      $slider.slick();
    }
  }

  unslickManager() {
    // unslick slider
    let $slider = $(this).find('.slider-show-wrapper');
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  async loadRecommendations(cartAddItems) {
    const query = JSON.stringify({
      "viewing_item": this.currentProduct == null ? null : this.currentProduct,
      "viewed_items": this.viewingItems,
      "last_adding_to_cart_item": cartAddItems ? cartAddItems[0] : this.cartItems[0],
      "cart_items": cartAddItems ? cartAddItems : this.cartItems
    });

    const fields = JSON.stringify(["item_group_id"])

    const res = await fetch(
      `https://uc-info.eu.abtasty.com/v1/reco/${window.shop.abtasty.recommend.site_id}/recos/${this.idRecommend}?variables=${query}&fields=${fields}`,
      {
        headers: {
          Authorization: `Bearer ${window.shop.abtasty.recommend.api_key}`
        }
      }
    );

    if (!res.ok) {
      return '';
    }

    const data = await res.json();

    // send recommended products to Klaviyo
    if (cartAddItems && this.dataKlaviyo) {
      const recommendedProductsIDs = data.items.map(item => item.item_group_id.toString());
      if (recommendedProductsIDs.length > 0) {
        if (window._learnq) {
          window._learnq.push(['identify', {
            'recommendedT2S': recommendedProductsIDs,
            'recommendedAbtasty': recommendedProductsIDs
          }]);
        }
      }
    }

    const idsFormatted = data.items.map(item => `id:${item.item_group_id}`).join(' OR ');
    return idsFormatted;
  }

  async getRecommendedProductList(cartAddItems) {
    const product_list = await this.loadRecommendations(cartAddItems);
    //const product_list = "id:6549453701192 OR id:6549473624136 OR id:6549484601416 OR id:6549464907848 OR id:6549464449096 OR id:6549453832264 OR id:6549454258248 OR id:6695116898376"
    await fetch(`${Shopify.routes.root}search?view=recommend-products&q=${product_list}&type=product&id=${this.productCardType}__${this.idRecommend}`, {
      method: 'GET'
    })
      .then((response) => response.text())
      .then((result) => {
        const isEmpty = !result || result.trim() === "";
        if (isEmpty) {
          // If the result is empty, we remove to avoid leaving the section empty only if it is not the cart section.
          if (this.productCardType != "cart") {
            this.parentElement?.remove();
          }
        } else {
          if (this.isSlider) {
            this.unslickManager();
          }

          this.contentElement.innerHTML = result;

          if (this.isSlider) {
            this.slickManager();
          }
        }
      })
      .catch((error) => {
        //console.error(error);
        if (this.productCardType != "cart") {
          this.parentElement?.remove();
        }
      });
  }
}

try {
  window.customElements.define('abtasty-recommend', AbtastyRecommend);
} catch (e) { }